import { IApiResponse } from "@interfaces/generic/IApiResponse.ts"
import { IPostBookRestaurantResponseApi } from "@interfaces/IPostBookRestaurantResponseApi.ts"
import { IPostBookRestaurantResponseCli } from "@interfaces/IPostBookRestaurantResponseCli.ts"

export const PostBookRestaurantAdapter = (
	response: IApiResponse<IPostBookRestaurantResponseApi>
): IPostBookRestaurantResponseCli => {
	const booking = response?.data?.booking
	return {
		booking: {
			...booking,
			qrCode: booking?.qr_code,
			startDate: booking?.start_date,
		},
	}
}
